export const setEvento = (evento = {}) => {
    localStorage.setItem('eventosession', JSON.stringify(evento));    
}

export const getEvento = () => {
    return JSON.parse(localStorage.getItem('eventosession'));
}

export const removeEvento = () => {
    localStorage.removeItem('eventosession');
}